/**
 * Single source of truth for the quick-checkout update-cart lifecycle status.
 * Shared across the prefetch inline hydration, the JS bridge payload and the
 * QuickCheckout context so the enum never drifts (e.g. `failure` vs `failed`).
 */
export enum QuickCheckoutCartApiStatus {
    LOADING = "loading",
    SUCCESS = "success",
    FAILED = "failed",
}
